import Instance from "../../../../Axios";

// New Actions for the app

const GetAllSetores = () => async (dispatch) => {
  await Instance()
    .get(`/energias/setores`)
    .then(({ data }) => {
      dispatch({ type: "GET_ALL_SETORES", payload: data.yData });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetAllSetores;
